export default __webpack_public_path__ + "static/media/rightarrow.6a078d40.svg";